import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type CareSummaryInputFields = {
  careSummary: string;
};

const CareSummaryInput = ({
  careSummaryFieldConfig,
}: {
  careSummaryFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<CareSummaryInputFields>();

  return (
    <TextArea
      label={t`Vårdsammanfattning`}
      showOptionalLabel={
        careSummaryFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.careSummary?.message}
      {...register("careSummary", {
        required: {
          value:
            careSummaryFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange vårdsammanfattning`,
        },
      })}
    />
  );
};

export default CareSummaryInput;
